export default __webpack_public_path__ + "static/media/icons8-email-send-96.d128f58c.svg";